import React, { useState } from 'react'
import { Box, Button, CircularProgress, Grid } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { ROUTES } from '../../router'
import LinkCard, { LinkCardProps } from './components/LinkCard'
import { AdminPanelSecObjects } from 'src/types/security'
import { SafetyComponent } from 'src/components/security'
import BadgeIcon from '@mui/icons-material/Badge'
import SecurityIcon from '@mui/icons-material/Security'
import LockIcon from '@mui/icons-material/Lock'
import AccountTreeIcon from '@mui/icons-material/AccountTree'
import TimelineIcon from '@mui/icons-material/Timeline'
import CachedIcon from '@mui/icons-material/Cached'
import toast from 'react-hot-toast'
import { HttpCacheGeneral } from 'src/http/httpCacheGeneral'

const cardLinkProps: LinkCardProps[] = [
    {
        to: ROUTES.PERFILES,
        title: 'Perfiles',
        icon: BadgeIcon,
        color: '#d97706',
        securityObject: AdminPanelSecObjects.LinkTablaPerfiles
    },
    {
        to: ROUTES.OBJETOS_SEGURIDAD,
        title: 'Objetos de Seguridad',
        icon: SecurityIcon,
        color: '#475569',
        securityObject: AdminPanelSecObjects.LinkTablaObjetosSeguridad
    },
    {
        to: ROUTES.PERMISOS,
        title: 'Permisos',
        icon: LockIcon,
        color: '#b91c1c',
        securityObject: AdminPanelSecObjects.LinkTablaPermisos
    },
    {
        to: `/${ROUTES.ADMIN_MASTER}/${ROUTES.ETAPAS}`,
        title: 'Etapas',
        icon: TimelineIcon,
        color: '#059669',
        securityObject: AdminPanelSecObjects.LinkTablaEtapas
    },
    {
        to: `/${ROUTES.ADMIN_MASTER}/${ROUTES.ETAPA_GRUPO_PERMISO}`,
        title: 'Permisos de Etapas por Grupo',
        icon: AccountTreeIcon,
        color: '#0f766e',
        securityObject: AdminPanelSecObjects.LinkTablaEtapaGrupoPermiso
    }
]

function AdminMaster() {
    const navigate = useNavigate()
    const [refreshing, setRefreshing] = useState(false)

    const handleRefreshCache = () => {
        setRefreshing(true)
        const promise = HttpCacheGeneral.refreshAll()
        toast.promise(promise, {
            loading: 'Actualizando cachés...',
            success: 'Cachés actualizados correctamente',
            error: 'Error al actualizar cachés'
        }).finally(() => setRefreshing(false))
    }

    return (
        <>
            <Box sx={{ mb: 3 }}>
                <Button variant='text' startIcon={<ArrowBackIcon />} onClick={() => navigate(`/${ROUTES.PANEL}`)}>
                    Volver
                </Button>
            </Box>
            <SafetyComponent code={AdminPanelSecObjects.BotonRefrescarCaches}>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 3 }}>
                    <Button
                        variant='outlined'
                        startIcon={refreshing ? <CircularProgress size={18} /> : <CachedIcon />}
                        onClick={handleRefreshCache}
                        disabled={refreshing}
                    >
                        Refrescar Cachés
                    </Button>
                </Box>
            </SafetyComponent>
            <Grid container spacing={3}>
                {cardLinkProps.map((cardProps, index) => (
                    <SafetyComponent code={cardProps.securityObject!}>
                        <Grid key={index} item xs={6} sm={4} md={3}>
                            <LinkCard {...cardProps} />
                        </Grid>
                    </SafetyComponent>
                ))}
            </Grid>
        </>
    )
}

export default AdminMaster
